/* Kids - UGC: resume from the cover after the native first-play listener is consumed. */
document.addEventListener( 'click', function kids_resumeUgcVideo ( event ) {
	if ( event.target.closest?.( '.kids_ugc-videos__product' ) ) {
		// Product navigation must not reach the native first-play listener.
		event.stopPropagation();
		return;
	}

	const kids_media = event.target.closest?.( '.kids_ugc-videos__media[data-kids_ugc-cover]' );
	const kids_overlay = event.target.closest?.( 'img, .kids_ugc-videos__play-button' );

	if ( kids_media && kids_overlay && kids_media.hasAttribute( 'loaded' ) && !kids_media.hasAttribute( 'playing' ) ) {
		kids_media.play();
	}
}, true );

/* Kids - Theme / Init */
document.addEventListener( 'DOMContentLoaded', function () {

	/* Kids - Add to cart fixed */
	const quickAdd = document.querySelector( 'product-quick-add' );
	const productForm = document.querySelector( '.product-info__buy-buttons > form[action="/cart/add"]' );
	const footer = document.querySelector( '.footer' );
	const stickyVariantMedia = window.matchMedia( '(max-width: 699px)' );
	let updateStickySupportVisibility = function () {};

	if ( quickAdd && productForm && footer ) {
		let productFormPassed = false;
		let footerReached = false;
		let observedDesktopQuickAdd = null;
		const desktopQuickAddObserver = new MutationObserver( updateQuickAddVisibility );

		function watchDesktopQuickAdd () {
			const desktopQuickAdd = document.querySelector( 'product-quick-add.kids_sticky-add-to-cart-desktop' );

			if ( desktopQuickAdd === observedDesktopQuickAdd ) {
				return desktopQuickAdd;
			}

			desktopQuickAddObserver.disconnect();
			observedDesktopQuickAdd = desktopQuickAdd;

			if ( desktopQuickAdd ) {
				desktopQuickAddObserver.observe( desktopQuickAdd, {
					attributeFilter: [ 'class' ]
				} );
			}

			return desktopQuickAdd;
		}

		function updateQuickAddVisibility () {
			const useKidsSticky = stickyVariantMedia.matches;
			const shouldShow = useKidsSticky && productFormPassed && !footerReached;
			const stickyQuickAdd = document.querySelector( 'product-quick-add.kids_sticky-add-to-cart' );
			const desktopQuickAdd = watchDesktopQuickAdd();
			const desktopStickyShouldMoveSupport = !useKidsSticky && desktopQuickAdd?.classList.contains( 'is-visible' );

			stickyQuickAdd?.classList.toggle( 'kids_sticky-is-visible', shouldShow );
			document.documentElement.classList.toggle( 'kids_sticky-add-to-cart-visible', shouldShow || Boolean( desktopStickyShouldMoveSupport ) );

			if ( !shouldShow ) {
				stickyQuickAdd?.classList.remove( 'is-visible' );
			}
		}

		updateStickySupportVisibility = updateQuickAddVisibility;

		const observer = new IntersectionObserver( ( entries ) => {
			entries.forEach( ( entry ) => {
				if ( entry.target === productForm ) {
					productFormPassed = entry.boundingClientRect.bottom < 0;
				}

				if ( entry.target === footer ) {
					footerReached = entry.isIntersecting;
				}
			} );

			updateQuickAddVisibility();
		}, { threshold: 0 } );

		observer.observe( productForm );
		observer.observe( footer );

		stickyVariantMedia.addEventListener( 'change', updateQuickAddVisibility );
	}

	let pendingStickyDrawerId = null;
	let pendingStickyDrawerAction = null;

	document.addEventListener( 'click', function ( event ) {
		const button = event.target.closest?.( '[data-kids_sticky-option]' );

		if ( !button ) return;

		const optionIndex = Number( button.dataset.kids_stickyOptionIndex );
		const optionCount = Number( button.dataset.kids_stickyOptionCount );

		pendingStickyDrawerId = button.closest( '.kids_sticky-add-to-cart__drawer' )?.id || null;
		pendingStickyDrawerAction = optionIndex < optionCount ? 'reopen' : 'close';
		event.preventDefault();

		const form = document.forms[ button.dataset.kids_stickyFormId ];
		const input = Array.from( form?.elements || [] ).find( function ( element ) {
			return element.matches( 'input[data-option-position]' ) &&
				element.dataset.optionPosition === button.dataset.kids_stickyOptionPosition &&
				element.value === button.dataset.kids_stickyOptionValue;
		} );

		if ( input ) {
			input.checked = true;
			input.dispatchEvent( new Event( 'change', { bubbles: true } ) );
		}
	} );

	function getKlarnaTriggerTarget () {
		const placement = Array.from( document.querySelectorAll( 'klarna-placement' ) ).find( function ( element ) {
			return !element.closest( 'quick-buy-drawer, product-quick-add' );
		} );

		if ( placement ) {
			return placement.shadowRoot?.querySelector( 'button, a, [role="button"]' ) || placement;
		}

		const appBlock = Array.from( document.querySelectorAll( 'div[id*="klarna_on_site_messaging_app_block"], div[data-block-id*="klarna_on_site_messaging_app_block"]' ) ).find( function ( element ) {
			return !element.closest( 'quick-buy-drawer, product-quick-add' );
		} );

		return appBlock?.querySelector( 'button, a, [role="button"]' ) || appBlock;
	}

	function syncKlarnaTriggers () {
		const hasKlarna = Boolean( getKlarnaTriggerTarget() );

		document.querySelectorAll( '[data-kids_klarna-trigger]' ).forEach( function ( button ) {
			button.hidden = !hasKlarna;
			button.disabled = !hasKlarna;
		} );
	}

	document.addEventListener( 'click', function ( event ) {
		const button = event.target.closest?.( '[data-kids_klarna-trigger]' );

		if ( !button ) return;

		const klarnaTarget = getKlarnaTriggerTarget();

		if ( !klarnaTarget ) {
			button.hidden = true;
			button.disabled = true;
			return;
		}

		klarnaTarget.click();
	} );

	syncKlarnaTriggers();
	setTimeout( syncKlarnaTriggers, 1000 );

	/* Kids - Sticky Add to cart variant drawer */
	document.querySelectorAll( 'form[is="product-form"]' ).forEach( function ( form ) {
		form.addEventListener( 'product:rerender', function () {
			setTimeout( syncKlarnaTriggers, 0 );
			setTimeout( updateStickySupportVisibility, 0 );

			if ( !pendingStickyDrawerAction ) return;

			const openDrawer = document.querySelector( '.kids_sticky-add-to-cart__drawer[open]' );
			const drawerId = pendingStickyDrawerId;
			const drawerAction = pendingStickyDrawerAction;

			pendingStickyDrawerId = null;
			pendingStickyDrawerAction = null;

			if ( drawerAction === 'close' ) {
				openDrawer?.remove();
				return;
			}

			openDrawer?.remove();

			setTimeout( function () {
				requestAnimationFrame( function () {
					const nextDrawer = document.getElementById( drawerId );

					if ( nextDrawer && typeof nextDrawer.show === 'function' ) {
						nextDrawer.show( false );
					}
				} );
			}, 0 );
		} );
	} );

	/* Kids - Countdown */
	const countdownElements = document.querySelectorAll( '.kids_countdown' );

	countdownElements.forEach( function ( el ) {
		const endDateStr = el.getAttribute( 'data-date-end' );
		const separator = el.getAttribute( 'data-separator' );
		const dayParts = el.getAttribute( 'data-day' );
		const [ singularDay, pluralDay ] = dayParts.split( '|' );

		if ( !endDateStr ) return;

		const endDate = new Date( endDateStr.replace( /-/g, '/' ) );
		if ( isNaN( endDate.getTime() ) ) return;

		function updateCountdown () {
			const now = new Date();
			const diff = endDate - now;

			if ( diff <= 0 ) {
				el.textContent = '';
				clearInterval( interval );
				return;
			}

			const days = Math.floor( diff / ( 1000 * 60 * 60 * 24 ) );
			const hours = Math.floor( ( diff / ( 1000 * 60 * 60 ) ) % 24 );
			const minutes = Math.floor( ( diff / ( 1000 * 60 ) ) % 60 );
			const seconds = Math.floor( ( diff / 1000 ) % 60 );

			let countdownText = separator;

			if ( days > 0 ) {
				countdownText += days + ' ' + ( days === 1 ? singularDay : pluralDay ) + ' ';
			}

			countdownText +=
        		String( hours ).padStart( 2, '0' ) + 'H ' +
        		String( minutes ).padStart( 2, '0' ) + 'M ' +
        		String( seconds ).padStart( 2, '0' ) + 'S';

        	el.textContent = countdownText;
		}

		updateCountdown();
		const interval = setInterval( updateCountdown, 1000 );
	} );

	/* Kids - TouchStart on Product Card */
	const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

	if ( isTouchDevice ) {
    	const cards = document.querySelectorAll( '.product-card__figure' );
    	const hoverTimers = new WeakMap();

    	cards.forEach( card => {
    		card.addEventListener( 'touchstart', () => {
    			if ( hoverTimers.has( card ) ) {
    				clearTimeout( hoverTimers.get( card ) );
    			}

    			card.classList.add( 'is-hovered' );

    			const timeoutId = setTimeout( () => {
    				card.classList.remove( 'is-hovered' );
    				hoverTimers.delete( card );
    			}, 6000 );

    			hoverTimers.set( card, timeoutId );
    		} );
    	} );
	}

	/* Kids - Submenu */
	const container = document.querySelector( '.image-link-blocks' );
	if ( container ) {
		const links = container.querySelectorAll( 'a' );
		const currentUrl = new URL( window.location.href );
		const currentPath = currentUrl.pathname.replace( /\/$/, '' );
		const currentFilter = currentUrl.searchParams.get( 'filter.p.product_type' );

		links.forEach( function ( link ) {
        	try {
        		const linkUrl = new URL( link.href, window.location.origin );
        		const linkPath = linkUrl.pathname.replace( /\/$/, '' );
        		const linkFilter = linkUrl.searchParams.get( 'filter.p.product_type' );

        		if ( linkPath === currentPath && linkFilter === currentFilter ) {
        			const parentItem = link.closest( '.image-link-blocks__item' );
        			if ( parentItem ) {
        				parentItem.classList.add( 'current', 'item' );
        			}
        		}
        	} catch ( e ) {
        		console.error( 'Invalid URL:', link.href );
        	}
		} );
	}

	/* Kids - Klaviyo */
	document.body.addEventListener( 'click', function ( e ) {
		const target = e.target.closest( 'a[href^="#klaviyo_openform_"]' );

		if ( target ) {
			e.preventDefault();

			const formId = target.getAttribute( 'href' ).split( '#klaviyo_openform_' )[ 1 ];
			if ( formId ) {
				window._klOnsite = window._klOnsite || [];
				window._klOnsite.push( [ 'openForm', formId ] );
			}
		}
	} );

	/* Kids - Gtag / Custom events */
	document.body.addEventListener( 'click', function ( event ) {
		if ( event.target.closest( '.product-form__share a.share-buttons__item, .product-form__share button.product-info__native-share' ) ) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push( {
				'event': 'kids_product_share'
			} );
		}
	} );

	/* Kids - Gtag / Product: Size helper */
	document.body.addEventListener( 'click', function ( event ) {
		if ( event.target.closest( '.product .kids_product-variant-size-helper button' ) ) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push( {
				'event': 'kids_product_helper_size_click'
			} );
		}
	} );

	/* Kids - Gtag / Product: Info accordion */
	document.body.addEventListener( 'click', function ( event ) {
		const accordion = event.target.closest( '.product-info__accordion' );
		if ( accordion ) {
			const accordionToggle = accordion.querySelector( '.accordion__toggle' );
			const accordionName = accordionToggle ? accordionToggle.querySelector( 'span' ).textContent.trim() : '';

			const eventName = accordion.getAttribute( 'aria-expanded' ) === 'true' ? 'kids_product_info_accordion_open' : 'kids_product_info_accordion_close';
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push( {
				'event': eventName,
				'event_target': accordionName
			} );
		}
	} );

	/* Kids - Gtag / Product: Complementary products */
	const mainProductSection = document.querySelector( '.shopify-section--main-product' );
	const productRecommendations = mainProductSection ? mainProductSection.querySelector( 'product-recommendations' ) : null;

	if ( productRecommendations ) {
		productRecommendations.addEventListener( 'click', function ( event ) {
			const target = event.target;
			let eventName = '';

			if ( target.getAttribute( 'is' ) === 'prev-button' ) {
				eventName = 'kids_product_completary_products_button_prev';
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push( {
					'event': eventName
				} );
			}

			else if ( target.getAttribute( 'is' ) === 'next-button' ) {
				eventName = 'kids_product_completary_products_button_next';
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push( {
					'event': eventName
				} );
			}

			else if ( target.closest( '.horizontal-product__info .kids_obf-link' ) ) {
				eventName = 'kids_product_completary_products_name_click';
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push( {
					'event': eventName
				} );
			}

			else if ( target.closest( '.horizontal-product__cta button' ) ) {
				eventName = 'kids_product_completary_products_add_to_cart';
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push( {
					'event': eventName
				} );
			}
		} );
	}

	/* Kids - Gtag / Product: FAQs */
	if ( document.querySelector( '.shopify-section--faq' ) ) {
		document.querySelector( '.shopify-section--faq' ).addEventListener( 'click', function ( event ) {
			const accordion = event.target.closest( '.accordion' );
			if ( accordion ) {
				const eventName = accordion.getAttribute( 'aria-expanded' ) === 'true' ? 'kids_product_faq_accordion_open' : 'kids_product_faq_accordion_close';
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push( {
					'event': eventName
				} );
			}
		} );
	}

	/* Kids - Theme / VIVA! Conversión */
	const atom = document.querySelectorAll( 'link[type=\'application/atom+xml\']' );
	atom.forEach( function ( el ) {
		if ( el.href.includes( document.URL ) ) {
			el.remove();
		}
	} );

	const oembed = document.querySelectorAll( 'link[type=\'application/json+oembed\']' );
	oembed.forEach( function ( el ) {
		if ( el.href.includes( document.URL ) ) {
			el.remove();
		}
	} );
	/* Kids - Theme / VIVA! Conversión */

	/* Obfuscate links */
	var desobfuscateOnRightClick = true;

	function kidsObfuscateClicked ( el, force_blank = false ) {
		const link = atob( el.getAttribute( 'data-o' ) );
		const _blank = el.getAttribute( 'data-b' );
		const delegate = el.getAttribute( 'data-d' );

		if ( _blank || force_blank ) {
			window.open( link );
		}
		else {
			if ( delegate !== '1' ) {
				location.href = link;
			}
		}
	}

	function shouldHandleEvent ( el, targetClass, excludedParentClass ) {
		return el.classList.contains( targetClass ) && !el.closest( excludedParentClass );
	}

	setTimeout( function () {
		const kidsLinks = document.querySelectorAll( '.kids_obf-link' );
		kidsLinks.forEach( function ( link ) {
			link.addEventListener( 'click', function ( event ) {
				let el = event.target;

              	if ( !el.classList.contains( 'kids_obf-link' ) ) {
					el = el.closest( '.kids_obf-link' );
				}
				if ( shouldHandleEvent( el, 'kids_obf-link', '.kids_deobf-link' ) ) {
					if ( event.metaKey || event.ctrlKey ) {
						const link = atob( el.getAttribute( 'data-o' ) );
						window.open( link, '_blank' );
						event.preventDefault();
					}
					else {
						kidsObfuscateClicked( el );
					}
				}
			} );

			link.addEventListener( 'mousedown', function ( event ) {
				if ( event.which === 2 ) {
					const el = event.target;
					if ( shouldHandleEvent( el, 'kids_obf-link', '.kids_debof-link' ) ) {
						kidsObfuscateClicked( el, true );
					}
				}
			} );

			link.addEventListener( 'contextmenu', function ( event ) {
				const el = event.target;
				if ( shouldHandleEvent( el, 'kids_obf-link', '.kids_deobf-link' ) ) {
					if ( desobfuscateOnRightClick ) {
						event.stopPropagation();

						const link = atob( el.getAttribute( 'data-o' ) );
						const _blank = el.getAttribute( 'data-b' );
						const wrapper = document.createElement( 'a' );
						wrapper.className = 'kids_deobf-link';
						wrapper.href = link;

						if ( _blank ) {
							wrapper.target = '_BLANK';
						}

						el.parentNode.insertBefore( wrapper, el );
						wrapper.appendChild( el );

						const newEvent = new MouseEvent( 'contextmenu', {
							bubbles: true,
							cancelable: true,
							view: window
						} );

						wrapper.dispatchEvent( newEvent );

						setTimeout( function () {
							if ( wrapper.parentNode ) {
								wrapper.parentNode.replaceChild( el, wrapper );
							}
						}, 10 );
					}
				}
			} );
		} );
	}, 2000 );

	/* Product - Variant */
	document.addEventListener( 'variant:change', function ( event ) {
		const variantId = event?.detail?.variant?.id ?? null;

		if ( !variantId ) {
			const selectedInput = document.querySelector( '[id^="product-info-"] .variant-picker input:checked + label.is-disabled' );

			if ( selectedInput ) {
				const firstAvailableLabel = selectedInput.closest( 'fieldset' )?.querySelector( 'label:not(.is-disabled)' );
				firstAvailableLabel?.click();
			}
		}
	} );

	/* Page - Puntos de venta */
	const countrySelect = document.getElementById( 'kids_stores-list-country-select' );
	if ( countrySelect ) {
		countrySelect.addEventListener( 'change', function () {
			const selectedCountry = this.value;

			const stateSelects = document.querySelectorAll( '.kids_stores-list-state-select' );
			stateSelects.forEach( select => {
				const parentElement = select.parentElement;
				const selectCountryCode = select.getAttribute( 'data-country-code' );

				if ( selectCountryCode === selectedCountry ) {
					parentElement.classList.add( 'active' );

					let event = new Event( 'change' );
					select.dispatchEvent( event );
				}
				else {
					parentElement.classList.remove( 'active' );
				}
			} );
		} );
	}

	const stateSelects = document.querySelectorAll( '.kids_stores-list-state-select' );
	if ( stateSelects ) {
		stateSelects.forEach( select => {
			select.addEventListener( 'change', function () {

				const selectedState = this.value;
				const selectedCountryCode = this.getAttribute( 'data-country-code' );

				const storeCards = document.querySelectorAll( '.kids_card-store' );
				storeCards.forEach( card => {
					const cardState = card.getAttribute( 'data-state' );
					const cardCountryCode = card.getAttribute( 'data-country-code' );

					if ( ( cardState === selectedState || '*' === selectedState ) && cardCountryCode === selectedCountryCode ) {
						card.parentElement.classList.add( 'active' );
					}
					else {
						card.parentElement.classList.remove( 'active' );
					}
				} );
			} );
		} );
	}

	const kids_storesRootSelector = '[data-kids-stores-list]';

	function kids_createStoreOption( value, label ) {
		const option = document.createElement( 'option' );
		option.value = value;
		option.textContent = label;
		return option;
	}

	async function kids_loadAdditionalStorePages( root, cardsContainer ) {
		const visitedUrls = new Set();
		let nextUrl = root.dataset.nextUrl;

		while ( nextUrl ) {
			const url = new URL( nextUrl, window.location.href );
			url.searchParams.set( 'section_id', root.dataset.sectionId );

			if ( visitedUrls.has( url.href ) ) {
				throw new Error( 'Repeated stores pagination URL' );
			}

			visitedUrls.add( url.href );

			const response = await fetch( url.href, {
				headers: { 'X-Requested-With': 'XMLHttpRequest' }
			} );

			if ( !response.ok ) {
				throw new Error( `Unable to load stores page: ${response.status}` );
			}

			const html = await response.text();
			const documentFragment = new DOMParser().parseFromString( html, 'text/html' );
			const nextRoot = documentFragment.querySelector( kids_storesRootSelector );
			const nextCardsContainer = nextRoot?.querySelector( '[data-kids-stores-cards]' );

			if ( !nextRoot || !nextCardsContainer ) {
				throw new Error( 'Invalid stores section response' );
			}

			Array.from( nextCardsContainer.children ).forEach( card => cardsContainer.append( card ) );
			nextUrl = nextRoot.dataset.nextUrl;
		}
	}

	function kids_setupStoreFilters( root, cardsContainer ) {
		const countryFilter = root.querySelector( '[data-kids-stores-country]' );
		const stateFilter = root.querySelector( '[data-kids-stores-state]' );
		const storeCards = Array.from( cardsContainer.querySelectorAll( '[data-kids-store-card]' ) );
		const countries = new Map();
		const statesByCountry = new Map();
		const sortLocale = root.dataset.locale || document.documentElement.lang || 'en';
		const compareLabels = ( first, second ) => first[ 1 ].localeCompare( second[ 1 ], sortLocale, { sensitivity: 'base' } );

		storeCards.forEach( card => {
			const country = card.dataset.country;
			const countryLabel = card.dataset.countryLabel;
			const state = card.dataset.state;
			const stateLabel = card.dataset.stateLabel;

			if ( !countries.has( country ) ) {
				countries.set( country, countryLabel );
				statesByCountry.set( country, new Map() );
			}

			if ( state && !statesByCountry.get( country ).has( state ) ) {
				statesByCountry.get( country ).set( state, stateLabel );
			}
		} );

		const sortedCountries = Array.from( countries.entries() ).sort( compareLabels );
		countryFilter.replaceChildren();
		sortedCountries.forEach( ( [ value, label ] ) => countryFilter.append( kids_createStoreOption( value, label ) ) );

		if ( countries.size === 0 ) {
			countryFilter.disabled = true;
			stateFilter.disabled = true;
			return;
		}

		const locale = sortLocale.toLowerCase().split( '-' )[ 0 ];
		const localeCountries = {
			es: 'espana',
			fr: 'france',
			pt: 'portugal'
		};
		const preferredCountry = localeCountries[ locale ];
		countryFilter.value = countries.has( preferredCountry ) ? preferredCountry : sortedCountries[ 0 ][ 0 ];
		countryFilter.disabled = false;

		function kids_filterStoreCards() {
			const country = countryFilter.value;
			const state = stateFilter.value;

			storeCards.forEach( card => {
				const matchesCountry = card.dataset.country === country;
				const matchesState = state === '*' || card.dataset.state === state;
				card.parentElement.classList.toggle( 'active', matchesCountry && matchesState );
			} );
		}

		function kids_populateStoreStates() {
			const states = statesByCountry.get( countryFilter.value ) || new Map();
			const sortedStates = Array.from( states.entries() ).sort( compareLabels );
			stateFilter.replaceChildren( kids_createStoreOption( '*', root.dataset.allLabel ) );
			sortedStates.forEach( ( [ value, label ] ) => stateFilter.append( kids_createStoreOption( value, label ) ) );
			stateFilter.disabled = states.size === 0;
			kids_filterStoreCards();
		}

		countryFilter.addEventListener( 'change', kids_populateStoreStates );
		stateFilter.addEventListener( 'change', kids_filterStoreCards );
		kids_populateStoreStates();
	}

	async function kids_initializeStoresList( root ) {
		if ( root.dataset.kidsStoresInitialized === 'true' ) {
			return;
		}

		root.dataset.kidsStoresInitialized = 'true';
		root.setAttribute( 'aria-busy', 'true' );

		const cardsContainer = root.querySelector( '[data-kids-stores-cards]' );
		if ( !cardsContainer ) {
			root.removeAttribute( 'aria-busy' );
			return;
		}

		try {
			await kids_loadAdditionalStorePages( root, cardsContainer );
		}
		catch ( error ) {
			console.error( 'Kids stores list could not load every store.', error );
		}

		if ( root.dataset.filtersEnabled === 'true' ) {
			kids_setupStoreFilters( root, cardsContainer );
		}
		root.removeAttribute( 'aria-busy' );
	}

	function kids_initializeAllStoresLists( container = document ) {
		container.querySelectorAll( kids_storesRootSelector ).forEach( kids_initializeStoresList );
	}

	kids_initializeAllStoresLists();
	document.addEventListener( 'shopify:section:load', event => kids_initializeAllStoresLists( event.target ) );

	/* Kids - Intercom */
	/*
	( function waitForIntercom() {

		if( typeof window.Intercom === 'function' ) {
			initIntercomTriggers();
		}
		else {
			setTimeout( waitForIntercom, 500 );
		}

	})();

	function initIntercomTriggers() {
		const COOKIE_NAME = 'intercom_triggered_event_01';
		let timeTriggerTimeout;

		// --- Funciones para manejar cookies ---
		const setCookie = ( name, value, days = 7 ) => {
			const date = new Date();
			date.setTime( date.getTime() + ( days * 24 * 60 * 60 * 1000 ) );
			document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/; SameSite=Lax`;
		};

		const getCookie = ( name ) => {
			const match = document.cookie.match( new RegExp( '(^| )' + name + '=([^;]+)' ) );
			return match ? decodeURIComponent( match[ 2 ] ) : null;
		};

		// --- Control de evento ya lanzado ---
		const markTriggered = () => {
			setCookie( COOKIE_NAME, Date.now().toString(), 7 );
		};

		const wasTriggered = () => {
			const lastTriggered = getCookie( COOKIE_NAME );
			if( !lastTriggered ) return false;
			const timeDiff = Date.now() - parseInt( lastTriggered, 10 );
			return timeDiff < ( 7 * 24 * 60 * 60 * 1000 );
		};

		const deactivateTriggers = () => {
			window.removeEventListener( 'scroll', handleScrollTrigger );
			document.removeEventListener( 'mouseout', handleExitIntent );
			clearTimeout( timeTriggerTimeout );
		};

		const showIntercomMessage = ( eventName ) => {
			if( wasTriggered() ) return;
			Intercom( 'trackEvent', eventName );
			markTriggered();
			deactivateTriggers();
		};

		const handleScrollTrigger = () => {
			if( wasTriggered() ) return;

			const scrollTop = window.scrollY || document.documentElement.scrollTop;
			const windowHeight = window.innerHeight;
			const documentHeight = document.documentElement.scrollHeight;

			if( scrollTop + windowHeight >= documentHeight * 0.75 ) {
				showIntercomMessage( 'show_new_message_v2' );
			}
		};

		const handleExitIntent = ( e ) => {
			if (
				!wasTriggered() &&
				!e.toElement &&
				!e.relatedTarget &&
				e.clientY <= 0 &&
				window.innerWidth > 1024
			) {
				showIntercomMessage( 'show_new_message_v2' );
			}
		};

		// --- Activación de triggers automáticos ---
		if( !wasTriggered() ) {
			window.addEventListener( 'scroll', handleScrollTrigger );
			document.addEventListener( 'mouseout', handleExitIntent );

			timeTriggerTimeout = setTimeout(() => {
				showIntercomMessage( 'show_new_message_v2' );
			}, 180000 );
		}

		// --- Activación de triggers manuales ---
		const elements = document.querySelectorAll( '[rel="kids_intercom:open"], a[href="#kids_intercom:open"]' );
		elements.forEach( function( element ) {
			element.addEventListener( 'click', function( event ) {
				event.preventDefault();

				let target = this.getAttribute( 'data-target' );
				target = ( target ) ? target : 'showNewMessage';

				if( typeof Intercom === 'function' ) {
					Intercom( target );
				}
			});
		});
	}
	*/

	/* Kids - Theme / End */

} );
/* Kids - Theme / End */
